import { render, staticRenderFns } from "./UniversalChart.vue?vue&type=template&id=e92eceb2"
import script from "./UniversalChart.vue?vue&type=script&lang=js"
export * from "./UniversalChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports